import { render, staticRenderFns } from "./MentoringRelationship.vue?vue&type=template&id=f0e8fba6&scoped=true"
import script from "./MentoringRelationship.vue?vue&type=script&lang=js"
export * from "./MentoringRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e8fba6",
  null
  
)

export default component.exports